import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const ex1 = await getThemePic(data?.customTheme, 'ex-1')


	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "0ktwOImdws",
				"width": 432.65,
				"height": 48.5625,
				"left": 32.65,
				"top": 10.09,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": "<p style=\"text-align: left;\"><span style=\"font-size: 28.57px;font-family: 微软雅黑;\">公司简介</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 1,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "ShbLKNOUvi",
				"width": 251.95,
				"height": 48.5625,
				"left": 52.66,
				"top": 375.54,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"\"><strong><span style=\"font-size: 28.57px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(0,0,0,1);\">${title}</span></span></span></strong></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "UlBqHmnWNj",
				"width": 559.29,
				"height": 40,
				"left": 52.66,
				"top": 410.48,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"\"><span style=\"color: rgba(253,0,0,1);\">${serial}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "UEW78boveY",
				"width": 11.81,
				"height": 64.96,
				"left": 39,
				"top": 375,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "#c00000",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#600000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 微软雅黑;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "igL5FEoEsL",
				"src": ex1,
				"width": 1001.41,
				"height": 341.88,
				"left": -1.98,
				"top": 0,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			}
		],
		background
	}
}